// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:28:06

export default {
  "id": "dta-2-maniac",
  "slug": "dta-2-maniac",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/88c37f6288ea4c3f9f7ef791459b246b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/88c37f6288ea4c3f9f7ef791459b246b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "DTA 2: Maniac",
      "description": "DTA 2: Maniac. Create chaos like GTA. Use a vast arsenal of weapons, steal bulldozers, buses, police cars, tanks and much more - destruction is all around!",
      "instructions": "Get out into the city and look for adventure.\nAutomatic targeting of the nearest enemy.\n\nWSDA - character control\nLeft mouse button - hit or shoot\nSpacebar - perform a roll\nE - get into the car",
      "genres": [
        "Adventure",
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "car",
        "police",
        "santa",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "DTA 2: 疯狂者",
      "description": "DTA 2: 疯狂。像 GTA 一样制造混乱。使用丰富的武器库，偷走推土机、公交车、警车、坦克等等——毁灭无处不在！",
      "instructions": "走出城市，寻找冒险。\n自动锁定最近敌人。\n\nWSDA - 角色控制\n左鼠标按钮 - 攻击或射击\n空格键 - 执行翻滚\nE - 进入汽车",
      "genres": [
        "冒险",
        "竞速与驾驶"
      ],
      "tags": [
        "三维",
        "汽车",
        "警察",
        "圣诞老人",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "DTA 2:瘋狂",
      "description": "DTA 2:瘋狂。像 GTA 一样製造混亂。使用廣泛的武器庫，搶奪推土機、巴士、警車、坦克等多種裝備——毀滅無處不在！",
      "instructions": "走出城市，尋找冒險。\n\n自動對準最近敵人。\n\nWSDA - 角色控制\n左鍵鼠標 - 攻擊或射擊\n空格鍵 - 执行翻滾\nE - 登上車輛",
      "genres": [
        "冒險",
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "警察",
        "聖誕老人",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "DTA 2:瘋狂者",
      "description": "DTA 2:瘋狂。造成如GTA般的混亂。使用廣闊的武器庫，搶走推土機、巴士、警車、坦克等等——毀滅四處蔓延！",
      "instructions": "離開城市，尋找冒險。\n自動追蹤最近的敵人。\n\nWSDA - 角色控制\n左鍵鼠標 - 攻擊或射擊\n空格鍵 - 扮裝翻滾\nE - 騎上車輛",
      "genres": [
        "冒險",
        "賽車及駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "警察",
        "聖誕老人",
        "武器"
      ]
    },
    "ja": {
      "title": "DTA 2: 狂気",
      "description": "DTA 2: マニアック。GTAのように混乱を起こせ。多様な武器を使用し、ブルドーザー、バス、警察車両、戦車など、多くの車両を盗め - 激しい破壊が至る所に広がる！",
      "instructions": "街に出て冒険を探そう。\n最も近い敵への自動ターゲティング。\n\nWSDA - キャラクターコントロール\n左マウスボタン - 攻撃または射撃\nスペースバー - ロール\nE - 車に乗る",
      "genres": [
        "アドベンチャー",
        "レース＆ドライビング"
      ],
      "tags": [
        "3D",
        "車",
        "警察",
        "サンタ",
        "武器"
      ]
    },
    "ko": {
      "title": "DTA 2: 매니악",
      "description": "DTA 2: 맨이アク. GTA처럼 혼란을 조성하세요. 다양한 무기를 사용하고,推土機, 버스, 경찰차, 탱크 등을 훔치세요 - 파괴가 얕지 않습니다!",
      "instructions": "도시로 나가서 모험을 찾아보세요.\n가장 가까운 적에 자동 타겟.\n\nWSDA - 캐릭터 제어\n좌鼠标 클릭 -殴打下射\n공백키 - 회전\nE - 차에 올라가기",
      "genres": [
        "모험",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "자동차",
        "경찰",
        "산타",
        "무기"
      ]
    },
    "fr": {
      "title": "DTA 2 : Maniaque",
      "description": "DTA 2: Fous. Créez le chaos comme dans GTA. Utilisez un large arsenal d'armes, volez des bulldozers, des bus, des voitures de police, des chars et bien plus encore - la destruction est partout !",
      "instructions": "Sortez en ville à la recherche de l'aventure.\nCible automatique de l'ennemi le plus proche.\n\nWSDA - contrôle du personnage\nBouton gauche de la souris - frapper ou tirer\nBarre d'espace - effectuer un roulement\nE - monter dans la voiture",
      "genres": [
        "Aventure",
        "Course & Conduite"
      ],
      "tags": [
        "3D",
        "voiture",
        "police",
        "Santa",
        "armes"
      ]
    }
  }
};
